module.exports = __webpack_public_path__ + "static/fonts/SVN-Nexa Light.6e7035af.ttf";